import { gql } from "@apollo/client";

import { adminStatusFragment } from "src/graphql/anti-fraud/fragments/AdminStatusFragment";
import { userFragment } from "src/graphql/anti-fraud/fragments/UserFragment";

export const shortAlertFragment = gql`
  fragment ShortAlertFragment on Alert {
    id
    decision
    origin
    caseVersions {
      current {
        typeCode
      }
    }
    status
    assignee {
      ...UserFragment
    }
    adminStatus {
      ...AdminStatus
    }
  }

  ${userFragment}
  ${adminStatusFragment}
`;
